import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, MessageCircle, Paperclip } from "lucide-react";

export default function SuccessPage() {
  const { state } = useLocation();
  return (
    <div className="min-h-screen flex items-center justify-center px-5" data-testid="success-page">
      <div className="max-w-md w-full text-center rise">
        <CheckCircle2 className="w-16 h-16 text-[#25D366] mx-auto" />
        <h1 className="text-3xl font-extrabold mt-4">¡Pedido #{state?.number ?? ""} listo!</h1>
        <p className="text-[#A89F91] mt-2 text-sm">Si WhatsApp no se abrió solo, tocá el botón verde y enviá el mensaje para confirmar tu pedido.</p>
        {state?.transfer && (
          <p className="mt-4 text-sm rounded-xl bg-amber-500/10 border border-amber-500/30 text-amber-200 p-3 flex gap-2 text-left" data-testid="success-receipt-reminder">
            <Paperclip className="w-4 h-4 shrink-0 mt-0.5" /> No te olvides de adjuntar la foto del comprobante de transferencia en el chat.
          </p>
        )}
        {state?.type === "retiro" && <p className="mt-3 text-sm text-[#d9cfc2]">Retirá en {state.address} · Espera aprox. {state.wait}</p>}
        {state?.url && (
          <a href={state.url} target="_blank" rel="noopener noreferrer" data-testid="success-open-whatsapp-btn"
            className="mt-6 w-full inline-flex items-center justify-center gap-2 py-4 rounded-full bg-[#25D366] text-[#0b2a17] font-extrabold">
            <MessageCircle className="w-5 h-5" /> Enviar pedido por WhatsApp
          </a>
        )}
        <Link to="/" className="block mt-4 text-sm text-[#A89F91] hover:text-amber-100" data-testid="success-back-menu-link">Volver al menú</Link>
      </div>
    </div>
  );
}
